export default "__VITE_ASSET__Bsa3_BKi__"